import React, { useState } from 'react';
import Profilepage from '../components/Profilepage'
import { useParams } from "react-router-dom";
import DashboardLayout from './layout/dashboardLayout';
import LoadingOverlay from '../components/loading/loading';

const UserProfileUpdatePage = (props) => {
    const { id } = useParams();
    const [loading] = useState(false);
    return (
        <DashboardLayout>
            {loading && <LoadingOverlay />}
            <Profilepage userID={id} />
        </DashboardLayout>
    )
};
export default UserProfileUpdatePage;